import React from "react";

export default function Privacy() {
  return (
    <div
      style={{
        padding: "50px 20px",
        background: "#020617",
        color: "#E2E8F0",
        fontFamily: "system-ui, -apple-system, sans-serif",
        lineHeight: "1.7",
        maxWidth: "900px",
        margin: "0 auto",
      }}
    >
      <h1 style={{ color: "#FFFFFF", marginBottom: 10 }}>
        Privacy Policy – Mechanic Finder
      </h1>

      <p style={{ marginBottom: 30, color: "#94A3B8" }}>
        Effective Date: March 2026
      </p>

      <p>
        Mechanic Finder ("we", "our", or "us") respects your privacy and is
        committed to protecting your personal information. This Privacy Policy
        explains how we collect, use, store, and protect your data when you use
        our mobile application and website.
      </p>

      {/* ============================ */}
      <h2 style={{ marginTop: 30, color: "#FFFFFF" }}>
        1. Information We Collect
      </h2>

      <h3>Personal Information</h3>
      <ul>
        <li>Full name</li>
        <li>Email address</li>
        <li>Phone number</li>
      </ul>

      <h3>Account & Service Data</h3>
      <ul>
        <li>User account ID and profile data</li>
        <li>Vehicle details (make, model, year, VIN, mileage)</li>
        <li>Appointments (date, time, service, address)</li>
        <li>Service selections and pricing</li>
        <li>Notes and booking details</li>
      </ul>

      <h3>Communication Data</h3>
      <ul>
        <li>Messages between users and admin (chat)</li>
        <li>Customer support interactions</li>
      </ul>

      <h3>Device & Technical Data</h3>
      <ul>
        <li>Push notification token</li>
        <li>IP address (for security and logging)</li>
        <li>Basic app usage data</li>
      </ul>

      <h3>Payment Information</h3>
      <ul>
        <li>Payment status and transaction IDs</li>
        <li>Deposit payments (e.g., $30 booking deposit)</li>
        <li>Payment provider reference (Stripe Payment Intent)</li>
      </ul>

      <p>
        <strong>
          Note: We do NOT store full credit card or banking information. All
          payments are securely processed by third-party providers such as
          Stripe.
        </strong>
      </p>

      {/* ============================ */}
      <h2 style={{ marginTop: 30, color: "#FFFFFF" }}>
        2. How We Use Your Information
      </h2>

      <ul>
        <li>Create and manage your account</li>
        <li>Schedule and manage service appointments</li>
        <li>Process booking deposits and payments</li>
        <li>Provide mobile mechanic services</li>
        <li>Enable communication between users and admin</li>
        <li>Send notifications (appointments, chat, updates)</li>
        <li>Improve app performance and user experience</li>
        <li>Monitor system security and prevent fraud</li>
      </ul>

      {/* ============================ */}
      <h2 style={{ marginTop: 30, color: "#FFFFFF" }}>
        3. Technology & Security
      </h2>

      <p>
        Our application uses modern technologies and security practices to
        protect your data:
      </p>

      <ul>
        <li><strong>Backend:</strong> FastAPI (Python)</li>
        <li><strong>Frontend:</strong> React Native (mobile app)</li>
        <li><strong>Authentication:</strong> JWT (secure token-based login)</li>
        <li><strong>Password Security:</strong> Hashed & encrypted passwords</li>
        <li><strong>Database:</strong> MongoDB</li>
        <li><strong>Hosting:</strong> Railway cloud infrastructure</li>
        <li><strong>API Protection:</strong> Role-based access control</li>
        <li><strong>Secure Transport:</strong> HTTPS encryption</li>
      </ul>

      {/* ============================ */}
      <h2 style={{ marginTop: 30, color: "#FFFFFF" }}>
        4. Data Sharing
      </h2>

      <p>
        We do <strong>NOT sell</strong> or share your personal data with third
        parties for advertising or marketing purposes.
      </p>

      <p>We may share data only when necessary:</p>

      <ul>
        <li>Payment processing (Stripe)</li>
        <li>Providing core app functionality</li>
        <li>Legal compliance</li>
        <li>Fraud prevention and security</li>
      </ul>

      {/* ============================ */}
      <h2 style={{ marginTop: 30, color: "#FFFFFF" }}>
        5. Data Retention
      </h2>

      <p>
        We retain your data only as long as necessary to provide services and
        meet legal obligations.
      </p>

      <p>
        You may request deletion of your account and associated data at any
        time.
      </p>

      {/* ============================ */}
      <h2 style={{ marginTop: 30, color: "#FFFFFF" }}>
        6. Your Rights
      </h2>

      <ul>
        <li>Access your personal data</li>
        <li>Update or correct your data</li>
        <li>Request account deletion</li>
      </ul>

      {/* ============================ */}
      <h2 style={{ marginTop: 30, color: "#FFFFFF" }}>
        7. Notifications
      </h2>

      <p>We may send push notifications related to:</p>

      <ul>
        <li>Appointments</li>
        <li>Messages</li>
        <li>System updates</li>
      </ul>

      <p>You can disable notifications in your device settings.</p>

      {/* ============================ */}
      <h2 style={{ marginTop: 30, color: "#FFFFFF" }}>
        8. Logs & Security Monitoring
      </h2>

      <ul>
        <li>IP address</li>
        <li>Login activity</li>
        <li>System events (registrations, actions)</li>
        <li>API request logs</li>
      </ul>

      <p>
        This data is used strictly for security, fraud prevention, and system
        monitoring.
      </p>

      {/* ============================ */}
      <h2 style={{ marginTop: 30, color: "#FFFFFF" }}>
        9. Changes to This Policy
      </h2>

      <p>
        We may update this Privacy Policy at any time. Updates will be posted on
        this page.
      </p>

      {/* ============================ */}
      <h2 style={{ marginTop: 30, color: "#FFFFFF" }}>
        10. Contact Us
      </h2>

      <p>If you have any questions, contact:</p>

      <p style={{ marginTop: 10 }}>
        Email: honourkorkmaz@gmail.com
        <br />
        Privacy Page: https://ozkorkmaz.ca/privacy
      </p>

      <div style={{ marginTop: 50, fontSize: 13, color: "#64748B" }}>
        © {new Date().getFullYear()} Mechanic Finder. All rights reserved.
      </div>
    </div>
  );
}